import { render, staticRenderFns } from "./HistamineItem.vue?vue&type=template&id=10366b6e&"
import script from "./HistamineItem.vue?vue&type=script&lang=js&"
export * from "./HistamineItem.vue?vue&type=script&lang=js&"
import style0 from "./HistamineItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports